import * as React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {MultiMenu, MultiMenuItem} from '@deviceinsight/ng-ui-components';
import {Button, Icon} from '@deviceinsight/ng-ui-basic-components';
import type {AssetGroup, NotificationTemplate} from '@deviceinsight/ng-ui-api-client';
import {fetchEmailTemplates} from '@deviceinsight/ng-ui-api-client';
import type {ActionType, UiAction} from '../../../modules/ruleengine/types';
import RuleActionEdit from './RuleActionEdit';
import {
	ACTION_TYPE_DEVICE,
	ACTION_TYPE_EMAIL,
	ACTION_TYPE_WEBSOCKET,
	MAX_ACTIONS
} from '../../../modules/ruleengine/config/consts';
import {createAction} from './ruleActionHelpers';
type Props = {
	actions: Array<UiAction>;
	onChange: (arg0: Array<UiAction>) => void;
	assetGroup: AssetGroup;
	title: React.ReactNode;
	canEdit: boolean;
	canReadNotificationTemplates: boolean;
};
type State = {
	emailTemplates: Array<NotificationTemplate>;
};
export default class RuleActionsContainer extends React.PureComponent<Props, State> {
	state = {
		emailTemplates: []
	};

	componentDidMount(): any {
		const {canReadNotificationTemplates} = this.props;

		if (!canReadNotificationTemplates) {
			return;
		}

		fetchEmailTemplates({
			locale: 'null',
			page: 0,
			size: 2000
		}).then((emailTemplates) => {
			this.setState({
				emailTemplates
			});
		});
	}

	addAction = (actionType: ActionType) => {
		const {actions, onChange} = this.props;
		const addedAction = createAction(actionType);

		if (addedAction) {
			const updatedActions = [...actions, addedAction];
			onChange(updatedActions);
		}
	};
	updateAction = (updatedAction: UiAction, index: number) => {
		const {actions, onChange} = this.props;
		const updatedActions = actions.map((action, actionIndex) => (actionIndex === index ? updatedAction : action));
		onChange(updatedActions);
	};
	removeAction = (index: number) => {
		const {actions, onChange} = this.props;
		const updatedActions = [...actions];
		updatedActions.splice(index, 1);
		onChange(updatedActions);
	};

	render() {
		const {actions, assetGroup, title, canEdit, canReadNotificationTemplates} = this.props;
		const {emailTemplates} = this.state;
		return (
			<div className="rule-action-container">
				<h3>{title}</h3>
				{actions.map((action, index) => {
					if (action.actionType !== ACTION_TYPE_WEBSOCKET) {
						const {
							metadata: {uuid}
						} = action;
						return (
							<RuleActionEdit
								action={action}
								onChange={this.updateAction}
								emailTemplates={emailTemplates}
								index={index}
								key={uuid}
								canEdit={canEdit}
								canReadNotificationTemplates={canReadNotificationTemplates}
								onRemove={this.removeAction}
								assetGroup={assetGroup}
							/>
						);
					}
				})}
				{actions.length < MAX_ACTIONS && canEdit && (
					<div className="action-add">
						<MultiMenu
							menuButton={
								<Button naked data-testid="action-menu-button">
									{actions.length === 0 && (
										<Trans i18nKey="ruleengine.edit.rule.addactions">Add Action</Trans>
									)}
									<Icon add />
								</Button>
							}>
							<MultiMenuItem onClick={() => this.addAction(ACTION_TYPE_DEVICE)}>
								<Trans i18nKey="ruleengine.edit.rule.deviceaction">Device Action</Trans>
							</MultiMenuItem>
							{canReadNotificationTemplates && (
								<MultiMenuItem onClick={() => this.addAction(ACTION_TYPE_EMAIL)}>
									<Trans i18nKey="ruleengine.edit.rule.emailaction">Send e-mail</Trans>
								</MultiMenuItem>
							)}
						</MultiMenu>
					</div>
				)}
			</div>
		);
	}
}
